import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Button, Divider, Spin } from 'antd';
import { Helmet } from 'react-helmet-async';
import './NewsDetail.css';
import { linyuanApi } from '../../../common/javascripts/common.js';

export default function NewsDetail(props) {
  const { pageName } = useParams();
  const location = useLocation();
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const [loading, setLoading] = useState(false);
  const {lang} = props;
  const backHref = lang ? '/news_en' : '/news_cn';

  useEffect(() => {
    // 优先尝试从 API 获取详情 (此时 pageName 为 ID)
    // 如果是纯数字 ID，则调用 API；否则当作 slug 直接处理（兼容旧链接）
    const isId = /^\d+$/.test(pageName);
    
    async function loadDetail() {
      setLoading(true);
      try {
        let fetchUrl;
        let currentTitle = '';
        let currentSummary = '';

        if (isId) {
          try {
            const res = await linyuanApi.get(`/news/${pageName}`);
            const data = res.data || res; // 适配 ApiResponse 结构
            // 注意：API 返回的字段可能与 NewsList 中的不一样，需确认
            // 根据 NewsController，返回的是 DetailData -> data (Map)
            // 字段名是下划线风格 (convertToMap)
            const newsData = data.data || data;
            
            // 处理多语言标题
            const langValue = lang ? 1 : 0;
            // API 返回 title (默认), title_cn, title_en 等
            // NewsController convertToMap 只返回 title, summary (DB中存储的值)
            // 假设 DB 中 title 是根据 lang 存储的？
            // NewsService create/update 时根据 lang 存储。
            // NewsController convertToMap 直接返回 title.
            // 所以这里直接用 title 即可。
            currentTitle = newsData.title || '';
            currentSummary = newsData.summary || '';
            
            const contentHtmlUrl = newsData.content_html_url || '';
            
            if (contentHtmlUrl.startsWith('http')) {
              fetchUrl = contentHtmlUrl;
            } else if (contentHtmlUrl) {
              fetchUrl = `/datas/newsContents/${contentHtmlUrl}/${contentHtmlUrl}.html`;
            } else {
              // 如果没有 content_html_url，尝试用 id? 不太可能，暂时 fallback
              fetchUrl = `/datas/newsContents/${pageName}/${pageName}.html`;
            }
          } catch (apiError) {
            console.error('Failed to fetch news detail from API', apiError);
            // API 失败，降级尝试直接用 pageName 拼接 HTML 路径
            fetchUrl = `/datas/newsContents/${pageName}/${pageName}.html`;
          }
        } else {
          // 非数字 ID，可能是 slug，直接拼接
          // 尝试从 state 获取 title/summary (旧方式兼容)
          const state = location.state || {};
          const searchParams = new URLSearchParams(location.search);
          currentTitle = state.title || searchParams.get('title') || '';
          currentSummary = state.summary || searchParams.get('summary') || '';
          
          const urlParam = state.url || searchParams.get('url');
          if (urlParam) {
            fetchUrl = urlParam;
          } else {
            fetchUrl = `/datas/newsContents/${pageName}/${pageName}.html`;
          }
        }

        setTitle(currentTitle);
        setSummary(currentSummary);

        if (fetchUrl) {
          const response = await fetch(fetchUrl);
          if (!response.ok) {
             throw new Error('Network response was not ok');
          }
          const html = await response.text();
          setContent(html);
        }
      } catch (error) {
        console.error('Error loading news content:', error);
        setContent(lang ? 'Failed to load content.' : '加载内容失败。');
      } finally {
        setLoading(false);
      }
    }

    loadDetail();
  }, [lang, pageName, location.search, location.state]);
  

  return (
    <div className="news_detail_container">
      <Helmet>
        <title>{`${title} - ${lang ? "LYNYN International" : "上海林炎"}`}</title>
        <meta name="keywords" content={summary || title} />
        <meta name="description" content={summary || title} />
      </Helmet>
      {loading && <div style={{ textAlign: 'center', padding: '20px' }}><Spin /></div>}
      {!loading && title && <h2 className="news-detail-title" style={{ textAlign: 'center', margin: '20px 0' }}>{title}</h2>}
      <Divider/>
      <div className="news-content" dangerouslySetInnerHTML={{ __html: content }} />
      <p></p>
      <Button type="primary" href={backHref} style={{ margin: 'auto' }}>返回</Button>
    </div>
  );
}